<template>
  <div class="login">
    <!-- <div class="video-mask"></div>
    <img
      :src="require('@/assets/login2/login_logo.png')"
      alt=""
      class="sys-logo"
    /> -->
    <div class="login-content">
      <div id="account-box" class="login-info-box">
        <div class="tabs">
          <div
            class="tab-item"
            :class="activeTab == 1 ? 'active' : ''"
            @click="() => (activeTab = 1)"
          >
            扫码注册
          </div>
          <div
            class="tab-item"
            :class="activeTab == 2 ? 'active' : ''"
            @click="() => (activeTab = 2)"
          >
            账号登录
          </div>
        </div>
        <div id="register-box" class="align-c" v-show="activeTab == 1">
          <p>请使用微信扫一扫登录</p>
          <img :src="wxQrCode" alt="qr-cdoe" class="qr-code-img" />
          <p>微信扫描二维码</p>
          <p>前往微信小程序【瑞为客管理端】注册账号</p>
        </div>
        <div class="form-box" v-show="activeTab == 2">
          <!-- <div class="login-type-tab">
            <span
              :class="{ active: templateType === 'accountLogin' }"
              @click="handelLoginChange('accountLogin')"
              >账号密码登录</span
            >
            <span
              :class="{ active: templateType === 'mobileLogin' }"
              @click="handelLoginChange('mobileLogin')"
              >手机验证码登录</span
            >
          </div> -->

          <template v-if="templateType == 'accountLogin'">
            <div class="form-field user-name" @keyup.enter="handleLogin">
              <div class="form-label">用户名</div>
              <el-input
                v-model="account"
                class="login-input"
                placeholder="请输入用户名"
                autocomplete="off"
              >
              </el-input>
            </div>
            <div class="form-field user-psw" @keyup.enter="handleLogin">
              <div class="form-label">密码</div>
              <el-input
                v-model="password"
                class="login-input"
                type="password"
                placeholder="请输入密码"
                autocomplete="off"
              >
              </el-input>
            </div>
            <div class="form-field" @keyup.enter="handleLogin">
              <div class="form-label">验证码</div>
              <div style="display: flex">
                <el-input
                  v-model="code"
                  class="login-input m-r-10"
                  placeholder="请输入验证码"
                  autocomplete="off"
                >
                </el-input>
                <div class="login-code-img">
                  <img :src="kapchaImg" @click="getKapchaImg" :captcha-key="kapchaKey"/>
                </div>
              </div>
            </div>
            <button
              class="login-confirm-btn font-16"
              v-loading="loginLoading"
              @click="handleLogin"
            >
              登 录
            </button>
          </template>
          <template v-if="templateType == 'mobileLogin'">
            <div class="form-field user-name" @keyup.enter="handleLogin">
              <div class="form-label">手机号码</div>
              <el-input
                v-model="mobileLogin.loginName"
                class="login-input"
                :placeholder="
                  templateType == 'accountLogin'
                    ? '请输入登录名'
                    : '请输入手机号'
                "
                autocomplete="off"
              >
              </el-input>
            </div>
            <div class="form-field" @keyup.enter="handleLogin">
              <div class="form-label">验证码</div>
              <div style="display: flex;">
                <el-input
                  v-model="mobileLogin.code"
                  class="login-input"
                  placeholder="验证码"
                  autocomplete="off"
                >
                </el-input>
                <el-button @click="getMobileCode('mobileLogin')" type="text">{{
                  buttonTexts.mobileLogin
                }}</el-button>
              </div>
            </div>
            <el-button
              class="login-confirm-btn w-p-100"
              v-loading="loginLoading"
              @click="handleLogin"
              >登 录</el-button
            >
          </template>
          <div style="display: flex; justify-content: space-between;">
            <span style="cursor: pointer;" @click="() => templateType = templateType == 'accountLogin' ? 'mobileLogin' : 'accountLogin'">
              {{templateType == 'accountLogin' ? '手机验证码登录' : '账号登录'}}
            </span>
            <span
              v-show="templateType == 'accountLogin'"
              @click="toResetPassword"
              class="forgot-password"
              >忘记密码</span
            >
          </div>
          <div class="law-info">
            登录即表明您阅读并同意<a
              class="law-info-link"
              @click="showLawNotice(1)"
              >用户服务协议</a
            >和<a class="law-info-link" @click="showLawNotice(2)">隐私政策</a>
          </div>
        </div>
      </div>
    </div>

    <RModal
      customClass="modal-panel"
      :title="noticeType == 1 ? '服务协议' : '隐私政策'"
      top="5vh"
      :show="noticeModal"
      width="70vw"
      @change="noticeModal = false"
      @close="noticeModal = false"
    >
      <template #content>
        <service-notice v-show="noticeType == 1"></service-notice>
        <law-notice v-show="noticeType == 2"></law-notice>
      </template>
    </RModal>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
import RModal from "@/components/common/RModal";
import JSEncrypt from "jsencrypt";
import lawNotice from "@/components/common/lawNotice.vue";
import serviceNotice from "@/components/common/serviceNotice.vue";
import QrCodeImage from "@/assets/img/imgs/wx-qr-code.jpg";
import { fetchWithoutToken } from "@/store/actions/fetch";

export default {
  name: "login",
  components: {
    RModal,
    lawNotice,
    serviceNotice,
  },
  data() {
    return {
      loginLoading: false,
      noticeModal: false,

      QrCodeImage,
      wxQrCode: "",
      templateType: "accountLogin",
      account: "",
      password: "",
      code: "",
      mobileLogin: { loginName: "", code: "" },
      registerData: {
        loginName: "",
        password: "",
        code: "",
        repassword: "",
        lawChecked: false,
      },
      forgetData: { loginName: "", password: "", code: "", repassword: "" },
      buttonTexts: {
        forgetData: "获取验证码",
        registerData: "获取验证码",
        mobileLogin: "获取手机验证码",
      },
      buttonDisabled: {
        forgetData: false,
        registerData: false,
        mobileLogin: false,
      },
      kapchaImg: "",
      noticeType: 1,
      activeTab: 2,
    };
  },
  computed: {
    ...mapState({
      // loginState: (state) => state.common.login,
      route: (state) => state.route,
      // LoginonUser: (state) => state.common.user,
    }),
  },
  created() {
    this.getKapchaImg();
    this.getWxQrCode();
  },
  // watch: {
  //   loginState: {
  //     handler(to, from) {
  //       if (to.status === 'success') {
  //         this.$router.replace({
  //           path: this.route.from.path,
  //           query: this.route.from.query,
  //         })
  //         this.getIndexPage()
  //         this.setFirstType('1')
  //       } else {
  //         this.alertToggle({
  //           alertType: 'danger',
  //           alertContent: to.msg,
  //         })
  //       }
  //     },
  //     deep: true,
  //   },
  // },
  mounted() {},
  methods: {
    ...mapActions(["login", "fetchData"]),
    ...mapMutations({
      setFirstType: "SET_FIRST_TYPE",
      setIsKeyLogin: "SET_IS_KEY_LOGIN",
    }),
    // 清除表单对象前后空格
    formParamsTrim(data) {
      for (let key in data) {
        if (data[key] === "" || data[key] == null) {
          data[key] = "";
        }
        if (typeof data[key] === "string") {
          data[key] = data[key].trim();
        }
      }

      return data;
    },
    // 处理登录
    handleLogin() {
      let params = {};

      if (this.templateType == "mobileLogin") {
        params = {
          loginName: this.mobileLogin.loginName,
          password: this.mobileLogin.code,
        };
        params = this.formParamsTrim(params);

        if (params.loginName === "") {
          this.$message.error("手机号不能为空");
          return;
        }
        if (params.password === "") {
          this.$message.error("验证码不能为空");
          return;
        }
      } else {
        params = {
          loginName: this.account,
          password: this.password,
          code: this.code,
        };
        params = this.formParamsTrim(params);

        if (params.loginName === "") {
          this.$message.error("用户名不能为空");
          return;
        }
        if (params.password === "") {
          this.$message.error("密码不能为空");
          return;
        }
        if (params.code === "") {
          this.$message.error("验证码不能为空");
          return;
        }
      }

      let options = {
        login: params.loginName,
        loginCert: params.password,
        loginType: this.templateType == "mobileLogin" ? 2 : 1,
        loginFrom: 1,
      };

      if (this.templateType != "mobileLogin") {
        options.loginCert = this.getEncrypt(options.loginCert);
        options.captcha = params.code;
        options.captchaKey = this.kapchaKey;
      }

      this.loginReq(options);
    },
    // 发起登录请求
    loginReq(params) {
      this.loginLoading = true;
      let url = "/user/login";
      fetchWithoutToken({
        url,
        method: "post",
        data: params,
        headers: { "Content-Type": "application/json" },
      })
        .then((response) => {
          const res = response.data || {};
          if (!res.success) {
            return this.$message.error(response.msg || "登录失败！");
          }

          this.loginUser = res.user;
          window.localStorage.setItem("Authorization", res.token); // 接口token缓存

          this.$store.commit("LOGIN_SUCCESS", {
            user: this.loginUser,
            perms: [],
            menu: [],
          });
          this.getPermsAndMenu();
        })
        .finally(() => {
          this.getKapchaImg();
          this.loginLoading = false;
        });
    },
    // 获取用户权限和菜单
    getPermsAndMenu() {
      let url = "USER.POST_PERMS_AND_MENU";
      this.loginLoading = true;
      this.fetchData({ url, method: "post" })
        .then((res) => {
          res = res || {};
          if (!res.success || !res.data || res.data.length == 0) {
            this.$message.error("获取菜单失败！");
            // 权限获取失败
            return;
          }
          let menu = res.data || [];
          this.menu = menu;
          let perms = res.permissions || [];
          window.localStorage.setItem("menu", JSON.stringify(menu));
          window.localStorage.setItem("perms", JSON.stringify(perms));
          //this.getIndexPage()
          if (this.loginUser.userType == 4) {
            this.getManagerInfo();
          } else {
            this.handlePageJump();
          }
        })
        .catch((err) => {
          this.$message.error("获取菜单失败！");
        })
        .finally(() => {
          this.loginLoading = false;
        });
    },
    // 处理页面跳转
    handlePageJump() {
      let toUrl =
        this.route.from.path == "/" ? (
          this.menu[0].path || this.menu[0].children[0].path
        ) : this.route.from.path;
      let toQuery = this.route.from.path == "/" ? "" : this.route.from.query;
      //登录后订单页面权限异常问题修复
      this.$nextTick(() => {
        setTimeout(() => {
          this.$router.replace({
            path: this.menu[0].path || this.menu[0].children[0].path,
            // query: toQuery,
          });
          this.setFirstType("1");
          this.loginLoading = false;
        }, 1000);
      });
    },
    // 获取经营者信息
    getManagerInfo() {
      let url = "MANAGER.GET_LIST";
      let params = {
        pageNumber: 1,
        pageSize: 1,
      };

      this.loginLoading = true;
      this.fetchData({ url, method: "get", params })
        .then((res) => {
          if (res.rowCount) {
            let manager = res?.data[0] || "";
            localStorage.setItem("manager", JSON.stringify(manager));
            if (!manager || manager.reviewStatus == 4) {
              this.$nextTick(() => {
                this.$router.push("/personal");
              });
            } else {
              this.handlePageJump();
            }
          } else {
            this.$nextTick(() => {
              this.$router.push("/personal");
            });
          }
        })
        .finally(() => {
          this.loginLoading = false;
        });
    },
    // 构建菜单
    buildMenus(data, parentId) {
      if (!data || !Array.isArray(data)) return [];
      let list = [];
      let dataArr = [...data];
      for (let i = 0; i < dataArr.length; i++) {
        if (dataArr[i].parentId == parentId) {
          list.push(dataArr[i]);
          dataArr.splice(i, 1);
          i--;
        }
      }
      list.forEach((item) => {
        let children = this.buildMenus(data, item.id);
        if (children && children.length) {
          item.children = children;
        } else {
          delete item.children;
        }
      });

      return list;
    },
    //登陆后默认页显示
    getIndexPage() {
      let firstPath = "";
      let status = false;
      let perms =
        "perms" in localStorage && localStorage.perms !== ""
          ? JSON.parse(localStorage.perms)
          : [];
      let menuPerms = {};
      perms.forEach((perm) => {
        menuPerms[perm.perm] = true;
      });
      // if (this.loginUser.indexPage != null && this.loginUser.indexPage != "") {
      //   firstPath = this.loginUser.indexPage;
      //   status = true;
      // }
      /*if (status) {
        this.$router.replace({
          path: firstPath,
        });
      }*/
    },
    // 获取微信小程序二维码，供注册使用
    getWxQrCode() {
      let url = "SYSTEM.PARAM.GET_LIST_WITHOUT_AUTH";
      let params = { name: "wx_qr_code" };
      this.fetchData({
        url,
        method: "post",
        params,
        headers: { "Content-Type": "application/json" },
      }).then((res) => {
        if (res && res.length) {
          this.wxQrCode = res[0].value || "";
        }
      });
    },
    handelLoginChange(templateType) {
      if (templateType == "accountLogin") {
        this.getKapchaImg();
      }
      // if (templateType == "forget") {
      //   $("#register-box").animate({ top: "-650px", opacity: "0.5" }, "slow");
      //   $("#account-box").animate({ top: "-650px", opacity: "0.5" }, "slow");
      //   $("#forget-box").animate({ top: "50%", opacity: "1" }, "slow");
      // } else if (templateType == "register") {
      //   $("#forget-box").animate({ top: "-650px", opacity: "0.5" }, "slow");
      //   $("#account-box").animate({ top: "-650px", opacity: "0.5" }, "slow");
      //   $("#register-box").animate({ top: "50%", opacity: "1" }, "slow");

      //   if (!this.wxQrCode) {
      //     this.getWxQrCode();
      //   }
      // } else {
      //   $("#forget-box").animate({ top: "-650px", opacity: "0.5" }, "slow");
      //   $("#register-box").animate({ top: "-650px", opacity: "0.5" }, "slow");
      //   $("#account-box").animate({ top: "50%", opacity: "1" }, "slow");
      // }

      this.templateType = templateType;
      this.account = "";
      this.password = "";
      this.code = "";
      // 这是什么写法？
      (this.registerData = {
        loginName: "",
        password: "",
        code: "",
        repassword: "",
      }),
        (this.forgetData = {
          loginName: "",
          password: "",
          code: "",
          repassword: "",
        });
    },
    getEncrypt(data) {
      let publickKey =
        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCMKvDoYmZuEUIX5iG6b2b1GuJUYaqAMGm+NGGlTO59KP9ccqbW6KOSu0Cp3sewbXQnzIg5QxlKzySPH9p/SlnQIAT3eMhPRAj4iP6QZ8ZH6WzVquNTNZSHomQ03Pt/Ffx1AogBQVMgdMHFTN18L6kud3NSXGqqGx1ds+q5rrVYSwIDAQAB";
      let crypt = new JSEncrypt();
      crypt.setPublicKey(publickKey);
      let ret = crypt.encrypt(data);
      return ret;
    },
    // 重置密码
    handleRestPwd() {
      let params = {
        password: this.forgetData.password,
        repassword: this.forgetData.repassword,
        phoneNum: this.forgetData.loginName,
        verifyCode: this.forgetData.code,
      };
      params = this.formParamsTrim(params);

      if (params.phoneNum == "") {
        this.$message.error("手机号不能为空");
        return false;
      }
      if (params.verifyCode == "") {
        this.$message.error("手机短信验证码不能为空");
        return false;
      }
      if (params.password == "") {
        this.$message.error("密码不能为空");
        return false;
      }
      if (params.password != params.repassword) {
        this.$message.error("两次输入密码不一致！");
        return false;
      }
      delete params.repassword;
      params.password = this.getEncrypt(params.password);

      const url = "USER.POST_FORGOT_PASSWORD";
      this.fetchData({ url, params, method: "post" })
        .then((res) => {
          if (res.success) {
            this.$message.success(res.info || "修改成功！");
            this.handelLoginChange("accountLogin");
          } else {
            this.$message.error(res.info || "修改失败！");
          }
        })
        .catch((err) => {
          this.$message.error(err || "修改失败！");
        });
    },
    // 获取验证码，非短信
    getKapchaImg() {
      // let timestamp = (new Date()).valueOf();
      // this.kapchaImg = window.axios.defaults.baseURL+'/login/kaptcha?timestam'+timestamp

      let url = "USER.GET_LOGIN_CODE";
      this.fetchData({ url, method: "get" }).then((res) => {
        this.kapchaImg = res.img;
        this.kapchaKey = res.key;
      });
    },
    settime(time, type) {
      if (time == 0) {
        this.buttonDisabled[type] = false;
        this.buttonTexts[type] = "获取验证码";
        return;
      } else {
        this.buttonDisabled[type] = true;
        this.buttonTexts[type] = "重新发送(" + time + ")";
        time--;
      }
      setTimeout(() => {
        this.settime(time, type);
      }, 1000);
    },
    // 获取手机验证码
    getMobileCode(type) {
      if (this.buttonDisabled[type]) {
        return false;
      }
      var phone = this[type].loginName;
      var reg = /^(1[3456789])\d{9}$/;
      if (phone === "") {
        this.$message.error("请输入手机号");
        return false;
      } else if (!reg.test(phone)) {
        this.$message.error("请输入正确格式的手机号！");
        return false;
      }

      const url = "USER.POST_PHONE_CHECK_CODE";
      this.fetchData({ url, params: { phoneNum: phone }, method: "post" })
        .then((res) => {
          if (res.success) {
            this.settime(60, type);
          } else {
            this.$message.error(res.info || "发送失败！");
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    showLawNotice(noticeType) {
      this.noticeType = noticeType;
      this.noticeModal = true;
    },
    // 忘记密码
    toResetPassword() {
      this.$router.push("/forgetPassword");
    },
  },
  beforeDestroy() {
    document.onkeydown = null;
  },
};
</script>
<style lang='less' scoped>
.login {
  .video-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("../assets/login2/login_bg.jpg") no-repeat;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
    z-index: 2;
  }
  .sys-logo {
    position: absolute;
    top: 35px;
    left: 55px;
    z-index: 999;
  }
  .login-content {
    // position: absolute;
    overflow: hidden;
    // width: 100vw;
    // height: 100vh;
    z-index: 3;
    border-radius: 8px;
    .login-info-box {
      width: 520px;
      // height: 510px;
      // position: absolute;
      // right: 10%;
      // margin-left: -200px;
      // margin-top: -280px;
      border-radius: 8px;
      background: white;
      // padding: 36px;
      top: 50%;
      opacity: 1;
      display: flex;
      flex-direction: column;
      .tabs {
        display: flex;
        .tab-item {
          flex: 1;
          text-align: center;
          border-bottom: 2px solid #e9e9eb;
          padding: 16px;
          cursor: pointer;
          &:first-child {
            border-right: 1px solid #fcbf0c;
          }
        }
        .active {
          color: #fcbf0c;
          border-bottom: 2px solid #fcbf0c;
        }
      }
      .form-box {
        // width: 450px;
        // margin-right: 40px;
        padding: 16px 32px;
        .login-type-tab {
          color: #666;
          margin-bottom: 30px;
          span {
            &:nth-child(1) {
              margin-right: 40px;
            }
            &.active {
              font-size: 18px;
              color: #000;
              font-weight: bold;
            }
          }
        }
        .form-field {
          margin-bottom: 8px;
          .form-label {
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 8px;
          }
          &.login-info-code,
          &.user-code {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .el-input {
              width: 332px;
            }
            .el-button.el-button--default {
              padding: 0;
            }
          }
          .el-input :deep(.el-input__inner) {
            width: 100%;
            height: 50px;
            border-radius: 8px;
            &:hover {
              border: 1px solid #ffc107 !important;
            }
            &:focus {
              border: 1px solid #00d2e1 !important;
              box-shadow: 0 0px 3px 0px #00d2e1;
            }
          }
          .login-code-img {
            cursor: pointer;
            width: 108px;
            height: 50px;
            border-radius: 10px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .login-confirm-btn {
          margin: 12px 0;
          width: 100%;
          height: 55px;
          border-radius: 8px;
          background-color: #fcbf0c;
          color: #fff;
        }
        .law-info {
          margin-top: 8px;
          color: #666;
          .law-info-link {
            color: #00d2e1;
          }
        }
        .forgot-password {
          cursor: pointer;
          color: #409EFF;
        }
      }
      #register-box {
        background-color: white;
        font-size: 12px;
        padding-top: 24px;
        .qr-code-img {
          width: 200px;
          height: 200px;
          margin: 10px;
        }
      }
    }

    ::-webkit-input-placeholder {
      color: #cad2db;
    }
    ::-moz-placeholder {
      color: #cad2db;
    }
    ::-ms-input-placeholder {
      color: #cad2db;
    }
  }
}
</style>
